import styled from 'styled-components';

export const Actions = styled.ul`
  display: flex;
  flex-flow: row wrap;
  padding-bottom: 10px;
  }
  >ul{
      display: flex;
      @media (max-width: 600px){
          flex-wrap: wrap;
      }
  }

  li {
    display: flex;
    justify-content: center;
    margin-right: 15px;
    padding-top: 10px;
    @media (max-width: 600px){
        margin-left: 0;
    }
    }
`;



// WEBPACK FOOTER //
// ./src/components/actions.js